import Vue from 'vue';

import MyComponents from '~/components/my';
import SysComponents from '~/components/sys';

Vue.use(MyComponents);
Vue.use(SysComponents);
